import React from 'react';
import { CookieHelper } from '@/helpers/CookieHelper';
import CompactDropdown, {
  CompactDropdownOptionProps,
} from '@/components/compactDropdown/CompactDropdown';
import { Heading, HeadingLevel } from '@/components/heading/Heading';
import { IconsDictionary } from '@/components/icon/Icon.types';
import IconButton from '@/components/iconButton/IconButton';
import { IconButtonTheme } from '@/components/iconButton/IconButton.types';
import ListingHeaderStyled from './ListingHeader.styled';

interface ListingHeaderProps {
  title: string;
  branches?: CompactDropdownOptionProps[];
  branch?: string;
  setBranch?: (e: any) => void;
}

const ListingHeader = ({
  title,
  branches = [],
  branch,
  setBranch,
}: ListingHeaderProps) => {
  return (
    <ListingHeaderStyled hasDropdown={branches?.length >= 1 ? true : false}>
      <Heading className="listing-header__title" hLevel={HeadingLevel.h2}>
        {title}
      </Heading>
      <div className="listing-header__col">
        <CompactDropdown
          options={branches}
          id="branches"
          label="Select a branch"
          defaultValue="all-branches"
          className="listing-header__dropdown"
          selected={branch}
          action={setBranch}
        />
        <IconButton
          icon={IconsDictionary.Refresh}
          srText="Refresh / Reload"
          action={() => {
            CookieHelper.DeleteCookie('x-block-config');
            CookieHelper.DeleteCookie('x-blocks-changed');
            location?.reload();
          }}
          theme={IconButtonTheme.Secondary}
          tooltipText="Reset changes"
        />
      </div>
    </ListingHeaderStyled>
  );
};

export default ListingHeader;
